interface AreaTagSetLassoPathProps {
  points: readonly number[][];
}

const normalizePoints = (points: readonly number[][]): [number, number][] =>
  points
    .filter((point) => point.length === 2 && point.every(Number.isFinite))
    .map((point) => [point[0], point[1]]);

export const buildSmoothLassoPath = (points: readonly number[][]): string => {
  const normalized = normalizePoints(points);
  if (normalized.length < 2) return '';
  if (normalized.length === 2) {
    return `M ${normalized[0][0]} ${normalized[0][1]} L ${normalized[1][0]} ${normalized[1][1]}`;
  }

  const last = normalized[normalized.length - 1];
  const first = normalized[0];
  const startX = (last[0] + first[0]) / 2;
  const startY = (last[1] + first[1]) / 2;
  const segments = normalized.map((point, index) => {
    const next = normalized[(index + 1) % normalized.length];
    return `Q ${point[0]} ${point[1]} ${(point[0] + next[0]) / 2} ${(point[1] + next[1]) / 2}`;
  });
  return `M ${startX} ${startY} ${segments.join(' ')} Z`;
};

export const AreaTagSetLassoPath = ({ points }: AreaTagSetLassoPathProps) => {
  const path = buildSmoothLassoPath(points);
  if (!path) return null;
  const closed = points.length >= 3;

  return (
    <g pointerEvents="none" aria-hidden="true">
      <path
        d={path}
        fill="none"
        stroke="hsl(var(--background))"
        strokeOpacity={0.9}
        strokeWidth={7}
        strokeLinejoin="round"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d={path}
        fill={closed ? 'hsl(var(--primary))' : 'none'}
        fillOpacity={closed ? 0.16 : 0}
        stroke="hsl(var(--primary))"
        strokeWidth={3}
        strokeLinejoin="round"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  );
};
